import React, { useState } from 'react'
import loginimg from './img/login-img.png';
import backarrow from './img/backarrrow.png';
import { Link } from 'react-router-dom';
import Nav from './components/Nav';
import SideMenu from './components/SideMenu';
import Overview from './components/Overview';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
export default function Dashboard() {
  const [loading, setLoading] = useState(true);
  return (
    <>


<main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          {loading ? <h1 className="h2"><i class="fa-solid fa-spinner fa-spin"></i></h1> : <h1 className="h2">Dashboard</h1>}

        </div>
        <div>

          <iframe
            src="https://lookerstudio.google.com/embed/reporting/251601bb-8bae-4334-a3dd-97e2916e562c/page/p_jq3cmy305c"
            onLoad={() => setLoading(false)}
            width={'1225'}
            height={'1000'}
            style={{ display: loading ? 'none' : 'block' }}
          />
        </div>
      </main>
    </>
  )
}
